import React from 'react';
import classNames from 'classnames';
import { string, node, bool } from 'prop-types';
import Heading from './Heading';
import Paragraph from './Paragraph';
import './Block.scss';

const Header = ({
  title,
  titleOptional,
  subtitle,
  isInline,
  titleClassNames,
}) => (
  <div className="block-header-container" data-selector-type="block-header">
    <div className="block-header-row-wrapper">
      <div className="block-header-column-wrapper">
        <div className="block-header">
          <Heading as="h2">
            {title && (
              <div
                className={classNames(
                  'title',
                  titleClassNames,
                  { inlineTitle: isInline }
                )}
                data-selector-type="title"
              >
                {title}
              </div>
            )}
            {titleOptional && (
              <div
                className={classNames(
                  'titleOptional',
                  { inlineTitleOptional: isInline }
                )}
              >
                {titleOptional}
              </div>
            )}
            {subtitle && (
              <div className="subtitle" data-selector-type="subtitle">
                <Paragraph>
                  {subtitle}
                </Paragraph>
              </div>
            )}
          </Heading>
        </div>
      </div>
    </div>
  </div>
);

Header.defaultProps = {
  title: null,
  titleOptional: null,
  subtitle: null,
  isInline: false,
  titleClassNames: '',
};

Header.propTypes = {
  title: string,
  titleOptional: string,
  subtitle: string,
  titleClassNames: string,
  isInline: bool,
};

const Block = ({ children }) => (
  <div className="block" data-selector-type="block">
    {children}
  </div>
);

Block.defaultProps = {
  children: null,
};

Block.propTypes = {
  children: node,
};

Block.Header = Header;

export default Block;
